import { Injectable, effect, inject, signal } from '@angular/core';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType, ReadyArgs, typeEventArgs } from 'keycloak-angular';
import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  keycloak = inject(Keycloak);

  readonly isAuthenticated = signal<boolean>(false);

  readonly user = signal<KeycloakProfile | null>(null);

  private prevAuth = false;

  constructor() {
    const keycloakSignal = inject(KEYCLOAK_EVENT_SIGNAL);

    effect(() => {
      const keycloakEvent = keycloakSignal();
      const ignoreEvents = [KeycloakEventType.TokenExpired, KeycloakEventType.AuthRefreshSuccess];

      if (ignoreEvents.includes(keycloakEvent.type)) {
        return;
      }

      const isAuthenticated = keycloakEvent.type === KeycloakEventType.Ready && typeEventArgs<ReadyArgs>(keycloakEvent.args);

      this.isAuthenticated.set(isAuthenticated);

      if (isAuthenticated && !this.prevAuth) {
        from(this.keycloak.loadUserProfile()).subscribe((user) => {
          this.user.set(user);
        });
      }

      if (!isAuthenticated && this.prevAuth) {
        this.user.set(null);
      }

      this.prevAuth = isAuthenticated;
    });
  }

  login(): void {
    void this.keycloak.login();
  }

  logout(): void {
    void this.keycloak.logout();
  }
}
